import { useContext } from "react";
import { Navigate } from "react-router-dom";
import CustomizerContext from "../_helper/Customizer";

/** Legacy URL: /credora/repayments/failed/:layout → overdue queue page. */
export default function RepaymentsFailedRedirect() {
  const { layoutURL } = useContext(CustomizerContext);
  const pub = process.env.PUBLIC_URL || "";
  return <Navigate to={`${pub}/credora/repayments/overdue/${layoutURL}`} replace />;
}
